// Import the combineReducers function from Redux
import { combineReducers } from 'redux';
// Import individual reducers from their respective files
import me from '../containers/user/reducers/me';
import loginData from '../containers/user/reducers/login';
import forgotPasswordMail from '../containers/user/reducers/forgotPasswordMail';
import forgotVerifyOtp from '../containers/user/reducers/forgotVerifyOtp';
import newPassword from '../containers/user/reducers/newPassword';
import country from '../containers/Utils/reducers/country';
import profile from '../containers/profile/reducers/profile';
import resendOtp from '../containers/user/reducers/resendOtp';
import unauthedCountryReducer from '../containers/unauthedUser/reducers/unauthedCountry';

export default combineReducers({
    loginData: loginData,
    me: me,
    forgotPasswordMail: forgotPasswordMail,
    forgotVerifyOtp: forgotVerifyOtp,
    newPassword: newPassword,
    country: country,
    profile: profile,
    resendOtp: resendOtp,
    unauthedUserInfo: unauthedCountryReducer,
});
